import type { IReactProps } from 'types';

function combineComponents(components: any[]) {
  return components.reduce(
    (AccumulatedComponents, CurrentComponent) => {
      return ({ children }: IReactProps) => {
        return (
          <AccumulatedComponents>
            <CurrentComponent>{children}</CurrentComponent>
          </AccumulatedComponents>
        );
      };
    },
    ({ children }: IReactProps) => <>{children}</>
  );
}

export default combineComponents;
